import { frontendURL } from 'dashboard/helper/URLHelper';
import {
  ROLES,
  CONVERSATION_PERMISSIONS,
} from 'dashboard/constants/permissions.js';
import ProductsOrdersIndex from './Index.vue';

const commonMeta = {
  permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/products-orders'),
    component: ProductsOrdersIndex,
    meta: commonMeta,
    children: [
      {
        path: '',
        name: 'products_orders_index',
        component: ProductsOrdersIndex,
        meta: commonMeta,
      },
    ],
  },
];
